<template>
  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding" style="padding-bottom: 0">
      <el-tabs class="tabs-rank" v-model="activeTabName" @tab-click="doTabClick">
        <el-tab-pane label="商品排行" name="goods"></el-tab-pane>
        <el-tab-pane label="类目排行" name="catalog"></el-tab-pane>
        <el-tab-pane label="品牌排行" name="brand"></el-tab-pane>
        <el-tab-pane label="客单价排行" name="price"></el-tab-pane>
        <el-tab-pane label="供应商排行" name="supplier"></el-tab-pane>
      </el-tabs>
      <div class="export">
        <el-button
          type="danger"
          :loading="loadingexport" @click="doExportRank"
          v-hasPermission="['report:rank:export']"
          >{{loadingexport ? "导出中 ..." : "导出数据"}}</el-button>
      </div>
      
    </el-col>
  </el-row>
  <el-row class="mainTableBox reportRank">
    <div
      class="searchBox mpadding"
      style="margin-left: -6px; margin-right: -6px;margin-bottom: 0;"
    >
      <div style="float: left">
        <span style="float: left; height: 30px; line-height: 30px"
          >统计时间：</span>
        <el-date-picker
          style="width: 210px"
          ref="dateRef"
          v-if="isShowDate"
          v-model="queryParam.date"
          type="daterange"
          unlink-panels
          range-separator="To"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="showDate"
        />
        <el-date-picker
          style="width: 230px"
          ref="date1Ref"
          v-if="isShowDate1"
          v-model="queryParam.date1"
          :type="dateType"
          placeholder="选择日期"
          @change="showDate"
        />

        <el-date-picker
          style="width: 230px"
          ref="date2Ref"
          v-if="isShowDate2"
          v-model="queryParam.date1"
          type="week"
          :format="queryParam.start + ' To ' + queryParam.end"
          placeholder="选择周"
          @change="showDate"
        />
      </div>

      <el-radio-group style="vertical-align: 4px; margin: 0 10px;float: left;">
        <el-radio-button
          :class="[dateTab == 'yesterday' ? 'active' : '']"
          label="yesterday"
          @click.prevent="doDateClick('yesterday')"
          >昨日</el-radio-button
        >
        <el-radio-button
          :class="{ active: dateTab == 'sevenday' }"
          label="sevenday"
          @click.prevent="doDateClick('sevenday')"
          >近7日</el-radio-button
        >
        <el-radio-button
          :class="{ active: dateTab == 'thirtyday' }"
          label="thirtyday"
          @click.prevent="doDateClick('thirtyday')"
          >近30日</el-radio-button
        >
        <el-radio-button
          :class="{ active: dateTab == 'day' }"
          label="day"
          @click.prevent="doDateClick('day')"
          >日</el-radio-button
        >
        <el-radio-button
          :class="{ active: dateTab == 'week' }"
          label="week"
          @click.prevent="doDateClick('week')"
          >周</el-radio-button
        >
        <el-radio-button
          :class="{ active: dateTab == 'month' }"
          label="month"
          @click.prevent="doDateClick('month')"
          >月</el-radio-button
        >
        <el-radio-button
          :class="{ active: dateTab == 'year' }"
          label="year"
          @click.prevent="doDateClick('year')"
          >年</el-radio-button
        >
        <el-radio-button
          :class="{ active: dateTab == 'diy' }"
          label="diy"
          @click.prevent="doDateClick('diy')"
          >自定义</el-radio-button
        >
      </el-radio-group>
      <el-select
        v-model="queryParam.customerid"
        filterable
        multiple
        placeholder="选择客户"
        @change="doCustomerClick"
        style="width: 150px; float: left;"
      >
        <template v-for="item in customerData" :key="item.customerid">
          <el-option :label="item.name" :value="item.customerid" />
        </template>
      </el-select>
      <el-select v-model="queryParam.supplierid" multiple filterable placeholder="选择供应商" @change="doSupplierClick" style="width:150px;float: left;">
          <template v-for="item in supplierData" :key="item.supplierid">
            <el-option :label="item.name" :value="item.supplierid" />
          </template>
        </el-select>
        <el-select v-model="queryParam.typeid" multiple filterable placeholder="选择商品类型" @change="doGoodsTypeClick" style="width:150px;float: left;">
          <template v-for="item in goodsTypeData" :key="item.typeid">
            <el-option :label="item.typename" :value="item.typeid" />
          </template>
        </el-select>
      <!-- <el-radio-group style="vertical-align: 4px; margin: 0 10px;float: left;">
        <el-radio-button
          :class="[customerType == '1' ? 'active' : '']"
          label="1"
          @click.prevent="doCutomerTypeClick('1')"
          >积分客户</el-radio-button
        >
        <el-radio-button
          :class="[customerType == '2' ? 'active' : '']"
          label="2"
          @click.prevent="doCutomerTypeClick('2')"
          >电商客户</el-radio-button
        >
        <el-radio-button
          :class="[customerType == '3' ? 'active' : '']"
          label="3"
          @click.prevent="doCutomerTypeClick('3')"
          >其他客户</el-radio-button
        >
      </el-radio-group> -->
      <el-button @click="resetSearch">重置</el-button>
    </div>

    <el-col :span="24" class="mpadding">
      <el-table
        :data="tableData"
        v-loading="loadingData"
        class="mainTable"
        row-key="orderid"
        @sort-change="sortChange"
      >
        <el-table-column label="序号" type="index" width="55" />
        <el-table-column label="供应商名称" prop="name" width="300" v-if="queryParam.tabtype=='supplier'"  />
        <el-table-column label="商品名称" prop="name" width="300" v-if="queryParam.tabtype=='goods'"  />
        <el-table-column label="类目" prop="catalogname" width="200" v-if="queryParam.tabtype=='goods'" />
        <el-table-column label="类目" prop="name" width="300" v-if="queryParam.tabtype=='catalog'"  />
        <el-table-column label="品牌" prop="name" width="300" v-if="queryParam.tabtype=='brand'" />
        <el-table-column label="客单价" prop="name" width="300" v-if="queryParam.tabtype=='price'">           
            <template #default="scope">
            <span v-text="util.getPriceRange(scope.row.pricerange)"></span>
          </template>
        </el-table-column>
        <el-table-column label="销售订单数" prop="sumOrderQty" width="200" sortable="custom"/>
        <el-table-column label="销售订单数环比" prop="hbOrderQty" width="200" v-if="queryParam.tabtype!=='catalog'"/>
        <el-table-column label="销售订单数同比" prop="tbOrderQty" width="200" v-if="queryParam.tabtype=='catalog'"/>
        <el-table-column label="销售额" prop="sumSaleamount"  width="200" sortable="custom"> 
          <template #default="scope">
            <span v-if="scope.row.sumSaleamount" v-text="(scope.row.sumSaleamount).toFixed(2)" />
          </template>
        </el-table-column>
        <el-table-column label="销售额环比" prop="hbSaleamount" width="200" v-if="queryParam.tabtype!=='catalog'"/>
        <el-table-column label="销售额同比" prop="tbSaleamount" width="200" v-if="queryParam.tabtype=='catalog'"/>
        <el-table-column label="毛利额" prop="sumMaolieamount" width="200" sortable="custom">
          <template #default="scope">
            <span v-if="scope.row.sumMaolieamount" v-text="(scope.row.sumMaolieamount).toFixed(2)" />
          </template>
        </el-table-column>
        <el-table-column label="毛利率" prop="sumMaolivamount" width="200" sortable="custom">
           <template #default="scope">
            <span v-if="scope.row.sumMaolivamount" v-text="(scope.row.sumMaolivamount*100).toFixed(2) + '%'" />
          </template>
        </el-table-column>
        <el-table-column label="毛利率环比" prop="hbMaolivamount"  width="200" v-if="queryParam.tabtype!=='catalog'"/>
        <el-table-column label="毛利率同比" prop="tbMaolivamount"  width="200" v-if="queryParam.tabtype=='catalog'"/>
        
      </el-table>
    </el-col>
  </el-row>

  <el-row class="mainTableBottom">

    <el-col :span="24">
      <div style="float: right">
        <el-pagination
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[20, 50, 100, 300, 600, 1000, 2000]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
        />
      </div>
    </el-col>
  </el-row>
</template>
          
<script setup>
import { ref, onMounted } from "vue";
import { ElTable } from "element-plus";
import { getReportGoodsRank,getReportCatalogRank,getReportBrandRank,getReportPriceRank,getReportSupplierRank,exportGoodsRank,exportCatalogRank,exportPriceRank,exportBrandRank,exportSupplierRank } from "@/api/report";

import { listCustomerCache } from "@/api/customer";
import { listSupplierCache } from "@/api/supplier";
import { listGoodsTypeCache } from "@/api/goodstype";

import dayjs from "dayjs";
import util from "@/util/tool.js";


const loadingData = ref(true);

const dateRef = ref();
const date1Ref = ref();
const date2Ref = ref();

const dateType = ref("date");
const customerType = ref("");
const dateTab = ref("day");
const isShowDate = ref(false);
const isShowDate1 = ref(true);
const isShowDate2 = ref(false);

const total = ref(0);
const pageSize = ref(20); //每页显示条数

const queryParam = ref({
  date: [],
  date1: "",

  tabtype: "goods",
  customerid: "",
  customertype: "",
  supplierid: '',
  typeid: '',
  pageNo: 1,
  pageSize: pageSize.value,
  datetype: "",
  start: "",
  end: "",

  orderBy: "",
  orderType: ""
});

const sortChange = ({ column, prop, order }) =>{
  console.log('----1',column, prop, order);
  // 有些列不需要排序，提前返回
  if (column.sortable !== 'custom') {
    return;
  }
  column.multiOrder = order;
  queryParam.value.orderBy = column.property
  queryParam.value.orderType = column.multiOrder

  getListReportRank()

  console.log('----2',column.property, column.multiOrder);
}

const resetSearch = () => {
  customerType.value = ''

  const start = new Date()
  dateTab.value = 'day'
  isShowDate.value =  isShowDate2.value =  false
  isShowDate1.value = true
  dateType.value = 'date'
  queryParam.value.date = []
  queryParam.value.date1 = dayjs(start).format("YYYY-MM-DD")

  getListReportRank()
}

const doDateClick = (flag) => {
  const start = new Date();
  const end = new Date();
  dateTab.value = flag;
  if (flag == "yesterday") {
    start.setTime(start.getTime() - 3600 * 1000 * 24);
    queryParam.value.date = [start, start];
    isShowDate1.value = isShowDate2.value = false;
    isShowDate.value = true;
  } else if (flag == "sevenday") {
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
    queryParam.value.date = [start, end];
    isShowDate1.value = isShowDate2.value = false;
    isShowDate.value = true;
  } else if (flag == "thirtyday") {
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
    queryParam.value.date = [start, end];
    isShowDate1.value = isShowDate2.value = false;
    isShowDate.value = true;
  } else if (flag == "day") {
    isShowDate.value = isShowDate2.value = false;
    isShowDate1.value = true;
    dateType.value = "date";
    queryParam.value.date = [];
    queryParam.value.date1 = dayjs(start).format("YYYY-MM-DD");
    // date1Ref.value.focus()
  } else if (flag == "week") {
    isShowDate.value = isShowDate1.value = false;
    isShowDate2.value = true;
    dateType.value = "week";
    queryParam.value.date = [];

    queryParam.value.date1 = dayjs().day(1).$d;
    console.log("queryParam.value.date1----weeek:", dayjs().day(1).$d);

    let startTime = dayjs(queryParam.value.date1).subtract(0, "day").$d;
    let endTime = dayjs(startTime).add(6, "day").$d;

    queryParam.value.start = dayjs(startTime).format("YYYY-MM-DD");
    queryParam.value.end = dayjs(endTime).format("YYYY-MM-DD");

    console.log("queryParam.value.start:", dayjs().day(1));
    // console.log('queryParam.value.end:',queryParam.value.end)
    // date2Ref.value.focus()
  } else if (flag == "month") {
    isShowDate.value = isShowDate2.value = false;
    isShowDate1.value = true;
    dateType.value = "month";
    queryParam.value.date = [];
    queryParam.value.date1 = dayjs(start).format("YYYY-MM");

    // date1Ref.value.focus()
  } else if (flag == "year") {
    isShowDate.value = isShowDate2.value = false;
    isShowDate1.value = true;
    dateType.value = "year";
    queryParam.value.date = [];
    queryParam.value.date1 = dayjs(start).format("YYYY");
    // date1Ref.value.focus()
  } else if (flag == "diy") {
    isShowDate1.value = isShowDate2.value = false;
    isShowDate.value = true;
    queryParam.value.date = [
      dayjs().startOf("month").format("YYYY-MM-DD"),
      dayjs().endOf("month").format("YYYY-MM-DD"),
    ];
    // dateRef.value.focus()
  }
  getListReportRank();
};

// const doCutomerTypeClick = (flag) => {
//   customerType.value = flag;
//   queryParam.value.customerid = "";
//   getListReportRank();
// };

const doCustomerClick = () => {
  customerType.value = "";
  getListReportRank();
};

const doSupplierClick = ()=> {
  getListReportRank()
}

const doGoodsTypeClick = ()=> {
  getListReportRank()
}


const showDate = () => {
  console.log("queryParam.value.date:", queryParam.value.date);
  console.log("queryParam.value.start:", queryParam.value.date1);

  if (dateTab.value == "week") {
    let startTime = dayjs(queryParam.value.date1).subtract(0, "day").$d;
    let endTime = dayjs(startTime).add(6, "day").$d;

    queryParam.value.start = dayjs(startTime).format("YYYY-MM-DD");
    queryParam.value.end = dayjs(endTime).format("YYYY-MM-DD");
  }
  getListReportRank();
};

const activeTabName = ref("goods");
const doTabClick = (tab) => {
  let status = 0;
  if (tab.props.name === "goods") {
    status = "";
  } else if (tab.props.name == "catalog") {
    status = 1;
  } else if (tab.props.name == "brand") {
    status = 2;
  } else if (tab.props.name == "price") {
    status = 3;
  } else if (tab.props.name == "supplier") {
    status = 4;
  }
  console.log(status)
  queryParam.value.tabtype = tab.props.name;
  queryParam.value.pageNo = 1;
  queryParam.value.pageSize = 15;
  getListReportRank();
};

const tableData = ref([]);

//客户列表API
const customerData = ref([]);
const customerReset = (customers) => {
  let dataTmp = [];
  customers.forEach((customer) => {
    customer.customerid = customer.customerid.toString();
    dataTmp.push(customer);
  });
  return dataTmp;
};
const getListCustomer = () => {
  listCustomerCache({ pageNo: 1, pageSize: 1000, status: 1 }).then((res) => {
    customerData.value = customerReset(res.data.extend.pages.list);
  });
};

//供应商列表API
const supplierData = ref([]);
const supplierReset = (suppliers) => {
  let dataTmp = [];
  suppliers.forEach((supplier) => {
    supplier.supplierid = supplier.supplierid.toString();
    dataTmp.push(supplier);
  });
  return dataTmp;
};
const getListSupplier = () => {
  listSupplierCache({ pageNo: 1, pageSize: 1000, status: 1 }).then((res) => {
    supplierData.value = supplierReset(res.data.extend.pages.list);
  });
};

//商品类型列表API
const goodsTypeData = ref([]);
const goodsTypeReset = (goodsTypes) => {
  let dataTmp = [];
  goodsTypes.forEach((goodsType) => {
    goodsType.typeid = goodsType.typeid.toString();
    dataTmp.push(goodsType);
  });
  return dataTmp;
};
const getListGoodsType = () => {
  listGoodsTypeCache({ pageNo: 1, pageSize: 1000, status: 1 }).then((res) => {
    goodsTypeData.value = goodsTypeReset(res.data.extend.pages.list);
  });
};

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListReportRank();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListReportRank();
};

//API
const getListReportRank = () => {
  let data = {
    datetype: "",
    start: "",
    end: "",
    tabtype: "goods",
    customerid: "",
    supplierid: '',
    typeid: '',
    customertype: "",
    pageNo: 1,
    pageSize: pageSize.value,

    orderBy: "",
    orderType: "",
  };

  data.datetype = dateTab.value;
  data.tabtype = queryParam.value.tabtype;
  data.customerid = queryParam.value.customerid;
  data.customertype = customerType.value;
  data.pageNo = queryParam.value.pageNo;
  data.pageSize = queryParam.value.pageSize;

  data.orderBy = queryParam.value.orderBy;
  data.orderType = queryParam.value.orderType;

  data.supplierid = queryParam.value.supplierid
  data.typeid = queryParam.value.typeid

  if (
    dateTab.value === "yesterday" ||
    dateTab.value === "sevenday" ||
    dateTab.value === "thirtyday"
  ) {
    data.start = dayjs(queryParam.value.date[0]).format("YYYY-MM-DD");
    data.end = dayjs(queryParam.value.date[1]).format("YYYY-MM-DD");
  } else if (dateTab.value === "day") {
    let tmp = dayjs(queryParam.value.date1).format("YYYY-MM-DD");
    data.start = tmp;
    data.end = tmp;
  } else if (dateTab.value === "week") {
    data.start = queryParam.value.start;
    data.end = queryParam.value.end;
  } else if (dateTab.value === "month") {
    let tmp = dayjs(queryParam.value.date1).format("YYYY-MM");
    // let monthnum = dayjs(tmp+'-01').daysInMonth()
    // data.start = tmp+'-01'
    // data.end = tmp+'-'+monthnum
    data.start = tmp;
  } else if (dateTab.value === "year") {
    let tmp = dayjs(queryParam.value.date1).format("YYYY");
    // data.start = tmp+'-01-01'
    // data.end = tmp+'-12-31'
    data.start = tmp;
  } else if (dateTab.value === "diy") {
    data.start = dayjs(queryParam.value.date[0]).format("YYYY-MM-DD");
    data.end = dayjs(queryParam.value.date[1]).format("YYYY-MM-DD");
  }

  let query = JSON.parse(JSON.stringify(data)); 
  query.customerids = data.customerid?data.customerid.join(','):''
  delete query.customerid

  query.supplierids = data.supplierid?data.supplierid.join(','):''
  delete query.supplierid

  query.typeids = data.typeid?data.typeid.join(','):''
  delete query.typeid

  console.log(query)
  loadingData.value = true;
  if (data.tabtype === 'catalog') {
    getReportCatalogRank(query).then((res) => {
        total.value = res.data.extend.pages.total;
        queryParam.value.pageSize = pageSize.value;
        tableData.value = res.data.extend.pages.list;
        loadingData.value = false;
    });
  } else if (data.tabtype === 'brand') {
    getReportBrandRank(query).then((res) => {
        total.value = res.data.extend.pages.total;
        queryParam.value.pageSize = pageSize.value;
        tableData.value = res.data.extend.pages.list;
        loadingData.value = false;
    });
  } else if (data.tabtype === 'price') {
    getReportPriceRank(query).then((res) => {
        total.value = res.data.extend.pages.total;
        queryParam.value.pageSize = pageSize.value;
        tableData.value = res.data.extend.pages.list;
        loadingData.value = false;
    });
  } else if (data.tabtype === 'supplier') {
    getReportSupplierRank(query).then((res) => {
        total.value = res.data.extend.pages.total;
        queryParam.value.pageSize = pageSize.value;
        tableData.value = res.data.extend.pages.list;
        loadingData.value = false;
    });
  } else {
    getReportGoodsRank(query).then((res) => {
        total.value = res.data.extend.pages.total;
        queryParam.value.pageSize = pageSize.value;
        tableData.value = res.data.extend.pages.list;
        loadingData.value = false;
    });
  }
  
};


let timer;
const loadingexport = ref(false)
const doExportRank = () => {
    let data = {
    datetype: "",
    start: "",
    end: "",
    tabtype: "goods",
    customerid: "",
    customertype: "",
    pageNo: 1,
    pageSize: pageSize.value,
  };

  data.datetype = dateTab.value;
  data.tabtype = queryParam.value.tabtype;
  data.customerid = queryParam.value.customerid;
  data.customertype = customerType.value;
  data.pageNo = queryParam.value.pageNo;
  data.pageSize = queryParam.value.pageSize;


  if (
    dateTab.value === "yesterday" ||
    dateTab.value === "sevenday" ||
    dateTab.value === "thirtyday"
  ) {
    data.start = dayjs(queryParam.value.date[0]).format("YYYY-MM-DD");
    data.end = dayjs(queryParam.value.date[1]).format("YYYY-MM-DD");
  } else if (dateTab.value === "day") {
    let tmp = dayjs(queryParam.value.date1).format("YYYY-MM-DD");
    data.start = tmp;
    data.end = tmp;
  } else if (dateTab.value === "week") {
    data.start = queryParam.value.start;
    data.end = queryParam.value.end;
  } else if (dateTab.value === "month") {
    let tmp = dayjs(queryParam.value.date1).format("YYYY-MM");
    // let monthnum = dayjs(tmp+'-01').daysInMonth()
    // data.start = tmp+'-01'
    // data.end = tmp+'-'+monthnum
    data.start = tmp;
  } else if (dateTab.value === "year") {
    let tmp = dayjs(queryParam.value.date1).format("YYYY");
    // data.start = tmp+'-01-01'
    // data.end = tmp+'-12-31'
    data.start = tmp;
  } else if (dateTab.value === "diy") {
    data.start = dayjs(queryParam.value.date[0]).format("YYYY-MM-DD");
    data.end = dayjs(queryParam.value.date[1]).format("YYYY-MM-DD");
  }

  let query = JSON.parse(JSON.stringify(data)); 
  query.customerids = data.customerid?data.customerid.join(','):''
  delete query.customerid
  console.log(query)

  loadingexport.value = true;

  if (data.tabtype === 'catalog') {
    exportCatalogRank(query).then((response) => {
      downloadExcel(response);
    });
  } else if (data.tabtype === 'brand') {
    exportBrandRank(query).then((response) => {
      downloadExcel(response);
    });
  } else if (data.tabtype === 'price') {
    exportPriceRank(query).then((response) => {
      downloadExcel(response);
    }); 
  } else if (data.tabtype === 'supplier') {
    exportSupplierRank(query).then((response) => {
      downloadExcel(response);
    });  
  } else {
    exportGoodsRank(query).then((response) => {
      downloadExcel(response);
    });
  }
  
};

const downloadExcel = (response) => {
  timer = setTimeout(() => {
    // 动画关闭需要一定的时间
    setTimeout(() => {
      loadingexport.value = false;
    }, 400);
    //下载
    const content = response.data;
    const blob = new Blob([content], {
      type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const downloadElement = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = decodeURI(response.headers["filename"]);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
  }, 1000);
  console.log(timer);
};

//onMounted方法
onMounted(() => {
  const start = new Date();
  //昨天为默认
  // start.setTime(start.getTime() - 3600 * 1000 * 24)
  // queryParam.value.date =  [start, start]
  //今日为默认
  start.setTime(start.getTime())
  queryParam.value.date1 =  start

  getListCustomer();
  getListSupplier();
  getListGoodsType();
  getListReportRank();
});
</script>

<style >
.export {
  float: right;
  position: absolute;
  right: 20px;
  z-index: 9;
  top: 20px;
}
.reportRank .searchBox {
  display: block;
  margin-bottom: 30px;
  width: 100%;
}
.reportRank .searchBox .el-radio-button__inner {
  padding: 8px 12px;
}
.reportRank .searchBox .active .el-radio-button__inner {
  color: #f65656;
}
.tabs-rank .el-tabs__item {
  color:#606266;
}
.tabs-rank .el-tabs__item.is-active {
  color:#606266;
}
.tabs-rank .el-tabs__item:hover {
  color:#606266;
}
.tabs-rank .el-tabs__active-bar {
  background: #ff4848;
}
</style>